import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { AllFailedModal } from './AllFailedModal';
import { SuccessModal } from './SuccessModal';
import { PartialFailedModal } from './PartialFailedModal';
import { MarginErrorModal } from './MarginErrorModal';

export const ResultModal = memo(({ isOpen, closeModal, type, errorInfo }) => {
  let modalContent;
  if (type === 'all') {
    const { title, info } = errorInfo || {}; // TODO default value
    modalContent = <AllFailedModal isOpen={isOpen} closeModal={closeModal} title={title} info={info} />;
  } else if (type === 'partial') {
    const { title, info, strategyResults } = errorInfo || {}; // TODO default value
    modalContent = (
      <PartialFailedModal
        isOpen={isOpen}
        closeModal={closeModal}
        title={title}
        info={info}
        strategyResults={strategyResults}
      />
    );
  } else if (type === 'margin') {
    const { currentOrderableMargin, marginRequired, shortfall } = errorInfo || {}; // TODO default value
    modalContent = (
      <MarginErrorModal
        isOpen={isOpen}
        closeModal={closeModal}
        currentOrderableMargin={currentOrderableMargin}
        marginRequired={marginRequired}
        shortfall={shortfall}
      />
    );
  } else {
    modalContent = <SuccessModal isOpen={isOpen} closeModal={closeModal} />;
  }

  return modalContent;
});

ResultModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  errorInfo: PropTypes.shape({}).isRequired, // TODO shape
};
